const DEFAULT_LANGUAGE = 'en';

/**
 * Gets the language of a (expected to be lower-cased) locale.
 * Ex. The language of "en-us" is "en".
 */
export const getLanguage = (lcLocale: string) => lcLocale.split('-')[0] || DEFAULT_LANGUAGE;
